import { Controller } from '@hotwired/stimulus';

const POLL_INTERVAL_MS = 5000;

export default class extends Controller {
  static values = {
    url: String,
    redirectUrl: String,
  };

  connect() {
    this.startPolling();
  }

  disconnect() {
    this.stopPolling();
  }

  startPolling() {
    this.stopPolling();
    this.timer = setInterval(() => this.poll(), POLL_INTERVAL_MS);
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      if (data.finished) {
        this.stopPolling();
        window.location.href = data.redirect_url || this.redirectUrlValue;
      }
    } catch (_e) {
      // network blip — retry on next tick
    }
  }
}
